import { render, staticRenderFns } from "./FaceFitCertificateContent.vue?vue&type=template&id=942bddd6&"
import script from "./FaceFitCertificateContent.vue?vue&type=script&lang=js&"
export * from "./FaceFitCertificateContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports